export default __webpack_public_path__ + "static/media/101t.c0748237.jpg";